// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import {
//   getCategoryServ,
//   addCategoryServ,
//   deleteCategoryServ,
//   updateCategoryServ,
// } from "../../services/category.service";
// import { triggerFileDownload } from "../../utils/fileDownload";
// import {
//   getUserListServ,
//   deleteUserServ,
//   getUserCartServ,
//   exportUserServ,
// } from "../../services/user.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";
// function UserList() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [showCartModal, setShowCartModal] = useState(false);
//   const [selectedCart, setSelectedCart] = useState([]);
//   const [actualTotal, setActualTotal] = useState(0);
//   const [discountedTotal, setDiscountedTotal] = useState(0);

//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetUserFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getUserListServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "Total Users",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     // {
//     //   title: "Completed Profile",
//     //   count: statics?.activeCount,
//     //   bgColor: "#63ED7A",
//     // },
//     // {
//     //   title: "Incomplete Profile",
//     //   count: statics?.inactiveCount,
//     //   bgColor: "#FFA426",
//     // },
//   ];
//   useEffect(() => {
//     handleGetUserFunc();
//   }, [payload]);

//   const handleDeleteUserFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this user?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteUserServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetUserFunc();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };

//   const [totalPages, setTotalPages] = useState(1);

//   useEffect(() => {
//     if (statics?.totalCount && payload.pageCount) {
//       const pages = Math.ceil(statics.totalCount / payload.pageCount);
//       setTotalPages(pages);
//     }
//   }, [statics, payload.pageCount]);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPayload({ ...payload, pageNo: newPage });
//     }
//   };

//   const handleViewCart = async (userId) => {
//     try {
//       const res = await getUserCartServ(userId);
//       const data = res.data;

//       if (data?.statusCode === 200) {
//         setSelectedCart(data.cartItems);
//         setActualTotal(data.actualTotalAmount);
//         setDiscountedTotal(data.discountedTotalAmount);
//         setShowCartModal(true);
//       } else {
//         toast.error(data?.message || "Failed to fetch cart");
//       }
//     } catch (err) {
//       toast.error("Something went wrong while fetching cart items");
//     }
//   };

//    const handleDownload = async (format) => {
//         try {
//           const response = await exportUserServ(payload, format);
//           const ext = format === "excel" ? "xlsx" : format;
//           triggerFileDownload(response.data, `UserList.${ext}`);
//         } catch (err) {
//           toast.error("Download failed");
//         }
//       };

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="User Management" selectedItem="Users" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center  my-4 topActionForm">
//             <div className="col-lg-5 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">Users</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({ ...payload, searchKey: e.target.value })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12 dropdown">
//               <button
//                 className="btn w-100 borderRadius24 text-light p-2 dropdown-toggle"
//                 style={{ background: "#227C9D" }}
//                 type="button"
//                 data-bs-toggle="dropdown"
//                 aria-expanded="false"
//               >
//                 Download
//               </button>
//               <ul className="dropdown-menu w-100">
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("txt")}
//                   >
//                     Download as TXT
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("excel")}
//                   >
//                     Download as Excel
//                   </button>
//                 </li>
//                 <li>
//                   <button
//                     className="dropdown-item"
//                     onClick={() => handleDownload("csv")}
//                   >
//                     Download as CSV
//                   </button>
//                 </li>
//               </ul>
//             </div>
//             {/* <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div> */}
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>
//                       <th className="text-center py-3">Profile </th>
//                       <th className="text-center py-3">Full Name</th>
//                       <th className="text-center py-3">Phone No.</th>
//                       <th className="text-center py-3">Email</th>
//                       {/* <th className="text-center py-3">Status</th> */}
//                       <th className="text-center py-3">
//                         Date & Time of Sign-Up
//                       </th>
//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton
//                                     width={50}
//                                     height={50}
//                                     borderRadius={25}
//                                   />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td className="text-center">
//                                   {(payload.pageNo - 1) * payload.pageCount +
//                                     i +
//                                     1}
//                                 </td>
//                                 <td className="text-center">
//                                   <img
//                                     src={v?.profilePic}
//                                     style={{ height: "30px" }}
//                                   />
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {[v?.firstName, v?.lastName]
//                                     .filter(Boolean)
//                                     .join(" ")}
//                                 </td>

//                                 <td className="font-weight-600 text-center">
//                                   {v?.phone}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.email}
//                                 </td>
//                                 {/* <td className="text-center">
//                                   {v?.profileStatus == "completed" ? (
//                                     <div
//                                       className="badge py-2"
//                                       style={{ background: "#63ED7A" }}
//                                     >
//                                       Varified
//                                     </div>
//                                   ) : (
//                                     <div
//                                       className="badge py-2 "
//                                       style={{ background: "#FFA426" }}
//                                     >
//                                       Incomplete
//                                     </div>
//                                   )}
//                                 </td> */}

//                                 <td className="text-center">
//                                   {v?.createdAt
//                                     ? moment(v.createdAt).format(
//                                         "DD/MM/YYYY HH:mm"
//                                       )
//                                     : "—"}
//                                 </td>
//                                 <td className="text-center">
//                                   <a
//                                     onClick={() => handleViewCart(v?._id)}
//                                     className="btn btn-info mx-2 text-light shadow-sm"
//                                   >
//                                     View Cart
//                                   </a>

//                                   <a
//                                     onClick={() => handleDeleteUserFunc(v?._id)}
//                                     className="btn btn-warning mx-2 text-light shadow-sm"
//                                   >
//                                     Delete
//                                   </a>
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>

//                 <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5 px-3 py-3 mt-4">
//                   <div className="d-flex align-items-center gap-2">
//                     <span className="fw-semibold text-secondary">Show</span>
//                     <select
//                       className="form-select form-select-sm custom-select"
//                       value={payload.pageCount}
//                       onChange={(e) =>
//                         setPayload({
//                           ...payload,
//                           pageCount: parseInt(e.target.value),
//                           pageNo: 1,
//                         })
//                       }
//                     >
//                       {[10, 25, 50, 100].map((v) => (
//                         <option key={v} value={v}>
//                           {v}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <nav>
//                     <ul className="pagination pagination-sm mb-0 custom-pagination">
//                       <li
//                         className={`page-item ${
//                           payload.pageNo === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo - 1)}
//                         >
//                           &lt;
//                         </button>
//                       </li>

//                       {[...Array(totalPages)].map((_, i) => {
//                         const page = i + 1;
//                         if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= payload.pageNo - 1 &&
//                             page <= payload.pageNo + 1)
//                         ) {
//                           return (
//                             <li
//                               key={page}
//                               className={`page-item ${
//                                 payload.pageNo === page ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => handlePageChange(page)}
//                               >
//                                 {page}
//                               </button>
//                             </li>
//                           );
//                         } else if (
//                           (page === payload.pageNo - 2 && page > 2) ||
//                           (page === payload.pageNo + 2 && page < totalPages - 1)
//                         ) {
//                           return (
//                             <li key={page} className="page-item disabled">
//                               <span className="page-link">...</span>
//                             </li>
//                           );
//                         }
//                         return null;
//                       })}

//                       <li
//                         className={`page-item ${
//                           payload.pageNo === totalPages ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo + 1)}
//                         >
//                           &gt;
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>

//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {showCartModal && (
//         <div className="custom-modal-backdrop">
//           <div className="custom-modal-content">
//             <h4 className="mb-4"> User Cart Items</h4>
//             <div className="table-container-with-sticky-header">
//               <table className="table table-bordered text-center align-middle">
//                 <thead className="table-light">
//                   <tr>
//                     <th>Image</th>
//                     <th>Product</th>
//                     <th>Qty</th>
//                     <th>Price</th>
//                     <th>Discounted</th>
//                     <th>Total</th>
//                     <th>Discounted Total</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {selectedCart.length > 0 ? (
//                     selectedCart.map((item, idx) => (
//                       <tr key={idx}>
//                         <td>
//                           <img
//                             src={item.productHeroImage}
//                             alt={item.name}
//                             style={{
//                               width: "60px",
//                               height: "60px",
//                               objectFit: "cover",
//                               borderRadius: "8px",
//                               boxShadow: "0 0 5px rgba(0,0,0,0.1)",
//                             }}
//                           />
//                         </td>
//                         <td>{item.name}</td>
//                         <td>{item.quantity}</td>
//                         <td>Rs {item.price}</td>
//                         <td>Rs {item.discountedPrice}</td>
//                         <td>Rs {item.totalItemPrice}</td>
//                         <td>Rs {item.totalItemDiscountedPrice}</td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td colSpan="7" className="text-center text-muted">
//                         No items in cart
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             <div className="d-flex justify-content-between mt-3 fs-5">
//               <strong>Total: Rs {actualTotal}</strong>
//               <strong>Discounted: Rs {discountedTotal}</strong>
//             </div>
//             <div className="text-end mt-4">
//               <button
//                 className="btn btn-secondary px-4"
//                 onClick={() => setShowCartModal(false)}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default UserList;

import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getUserListServ,
  deleteUserServ,
  getUserCartServ,
  exportUserServ,
} from "../../services/user.service";
import { triggerFileDownload } from "../../utils/fileDownload";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";

/* ─── Scoped styles — same design language as OrderList / ProductList ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=JetBrains+Mono:wght@500;600&display=swap');

  .ul-root {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'DM Sans', 'Segoe UI', sans-serif;
  }

  /* ── Stat grid ── */
  .ul-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 320px);
    gap: 14px;
    margin-bottom: 22px;
  }

  .ul-stat-card {
    background: #fff;
    border-radius: 14px;
    padding: 18px 20px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  .ul-stat-icon {
    width: 46px; height: 46px;
    border-radius: 12px;
    background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    font-size: 22px;
    color: #a60808;
    flex-shrink: 0;
  }
  .ul-stat-val {
    font-size: 26px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
    font-family: 'JetBrains Mono', monospace;
  }
  .ul-stat-lbl {
    font-size: 14px;
    color: #828282;
    margin-top: 5px;
    font-weight: 500;
  }

  /* ── Toolbar ── */
  .ul-toolbar {
    background: #fff;
    border-radius: 14px;
    padding: 18px 22px;
    border: 1px solid #f0eded;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 16px;
  }
  .ul-toolbar-title {
    font-size: 20px;
    font-weight: 700;
    color: #1c0a0a;
    margin-right: auto;
  }

  .ul-input {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #444;
    background: #f9f9f9;
    outline: none;
    min-width: 200px;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-input:focus { border-color: #f0c0b8; }
  .ul-input::placeholder { color: #bbb; }

  .ul-select {
    height: 40px;
    border-radius: 10px;
    border: 1px solid #f0eded;
    padding: 0 14px;
    font-size: 14px;
    color: #555;
    background: #f9f9f9;
    outline: none;
    cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-select:focus { border-color: #f0c0b8; }

  /* buttons */
  .ul-btn {
    height: 40px;
    padding: 0 18px;
    border-radius: 10px;
    border: none;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 7px;
    white-space: nowrap;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-btn-blue { background: #a60808; color: #fff; }
  .ul-btn-blue:hover { background: #2471a3; }

  
  /* download dropdown */
  .ul-download-wrap { position: relative; }
  .ul-dropdown-menu {
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    background: #fff;
    border: 1px solid #f0eded;
    border-radius: 10px;
    padding: 6px;
    z-index: 200;
    min-width: 190px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.09);
  }
  .ul-dropdown-item {
    display: block; width: 100%;
    padding: 9px 14px;
    font-size: 14px;
    color: #444; background: none; border: none;
    border-radius: 7px; text-align: left; cursor: pointer;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-dropdown-item:hover { background: #fdf2f1; color: #a60808; }

  /* ── Table card ── */
  .ul-table-wrap {
    background: #fff;
    border-radius: 14px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }
  .ul-table-scroll { overflow-x: auto; }
  .ul-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
  }
  .ul-table thead tr { background: #fdf2f1; }
  .ul-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 12px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }
  .ul-table td {
    padding: 14px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 15px;
  }
  .ul-table tbody tr:hover td { background: #fdfafa; }

  /* sr */
  .ul-sr { font-size: 13px; color: #bbb; font-family: 'JetBrains Mono', monospace; }

  /* user cell */
  .ul-user-cell { display: flex; align-items: center; gap: 12px; }
  .ul-avatar {
    width: 40px; height: 40px;
    border-radius: 12px;
    object-fit: cover;
    border: 1px solid #f0eded;
    background: #fdf2f1;
    flex-shrink: 0;
  }
  .ul-avatar-initials {
    width: 40px; height: 40px;
    border-radius: 12px;
    background: #fdf2f1;
    border: 1px solid #f0c0b8;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 700; color: #a60808;
    flex-shrink: 0;
  }
  .ul-user-name { font-size: 15px; font-weight: 600; color: #1c0a0a; }
  .ul-user-sub  { font-size: 12px; color: #bbb; margin-top: 1px; }

  /* contact info */
  .ul-mono { font-family: 'JetBrains Mono', monospace; font-size: 14px; color: #555; }
  .ul-email { font-size: 14px; color: #555; }

  /* date */
  .ul-date-main { font-size: 14px; color: #333; }
  .ul-date-sub  { font-size: 12px; color: #bbb; margin-top: 2px; font-family: 'JetBrains Mono', monospace; }

  /* action buttons */
  .ul-cart-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
    margin-right: 6px;
  }
  .ul-cart-btn:hover { background: #fdf2f1; border-color: #f0c0b8; color: #a60808; }

  .ul-del-btn {
    height: 34px; padding: 0 14px;
    border-radius: 9px;
    border: 1px solid #fcd9a0; background: #fff5e6;
    font-size: 14px; color: #e67e22;
    cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-del-btn:hover { background: #fdecea; border-color: #f0c0b8; color: #a60808; }

  /* skeleton */
  .ul-skel-cell { padding: 14px 16px; border-top: 1px solid #f7f5f5; }

  /* pagination */
  .ul-pagination {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 12px;
    padding: 16px 22px;
    border-top: 1px solid #f7f5f5;
  }
  .ul-show-row { display: flex; align-items: center; gap: 8px; font-size: 14px; color: #888; }
  .ul-page-btns { display: flex; align-items: center; gap: 5px; }
  .ul-pg-btn {
    width: 36px; height: 36px;
    border-radius: 9px;
    border: 1px solid #f0eded; background: #fff;
    font-size: 14px; color: #555;
    cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.18s;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-pg-btn.active { background: #a60808; color: #fff; border-color: #a60808; }
  .ul-pg-btn:hover:not(.active):not(:disabled) { background: #fdf2f1; color: #a60808; }
  .ul-pg-btn:disabled { opacity: 0.4; cursor: default; }

  /* ── Cart Modal ── */
  .ul-modal-overlay {
    position: fixed; inset: 0;
    background: rgba(28,10,10,0.45);
    display: flex; align-items: center; justify-content: center;
    z-index: 1050;
    padding: 20px;
  }
  .ul-modal {
    background: #fff;
    border-radius: 18px;
    width: 820px;
    max-width: 100%;
    max-height: 88vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0,0,0,0.18);
    font-family: 'DM Sans', sans-serif;
  }
  .ul-modal-header {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f0eded;
    flex-shrink: 0;
  }
  .ul-modal-title { font-size: 17px; font-weight: 700; color: #1c0a0a; display: flex; align-items: center; gap: 8px; }
  .ul-modal-title-icon {
    width: 30px; height: 30px;
    border-radius: 8px; background: #fdf2f1;
    display: flex; align-items: center; justify-content: center;
    color: #a60808; font-size: 15px;
  }
  .ul-modal-close {
    width: 32px; height: 32px;
    border-radius: 8px; border: 1px solid #f0eded;
    background: #f9f9f9; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    color: #888; font-size: 16px; transition: all 0.15s;
  }
  .ul-modal-close:hover { background: #fdf2f1; color: #a60808; border-color: #f0c0b8; }

  .ul-modal-body {
    padding: 0;
    overflow-y: auto;
    flex: 1;
  }

  /* cart table */
  .ul-cart-table { width: 100%; border-collapse: collapse; font-size: 14px; }
  .ul-cart-table thead tr { background: #fdf2f1; position: sticky; top: 0; z-index: 1; }
  .ul-cart-table th {
    padding: 12px 16px;
    font-size: 11px; font-weight: 700;
    color: #a60808; text-transform: uppercase; letter-spacing: 0.6px;
    text-align: left; white-space: nowrap;
  }
  .ul-cart-table td {
    padding: 13px 16px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 14px;
  }
  .ul-cart-table tbody tr:hover td { background: #fdfafa; }

  .ul-cart-img {
    width: 52px; height: 52px;
    border-radius: 10px; object-fit: cover;
    border: 1px solid #f0eded; background: #fdf2f1;
  }
  .ul-cart-name { font-size: 14px; font-weight: 600; color: #1c0a0a; }
  .ul-cart-qty {
    display: inline-flex; align-items: center; justify-content: center;
    width: 28px; height: 28px;
    border-radius: 8px; background: #fdf2f1;
    color: #a60808; font-weight: 700; font-size: 13px;
    font-family: 'JetBrains Mono', monospace;
  }
  .ul-cart-price { font-family: 'JetBrains Mono', monospace; font-size: 14px; color: #555; }
  .ul-cart-price.main { font-weight: 700; color: #1c0a0a; }
  .ul-cart-empty { padding: 40px; text-align: center; color: #bbb; font-size: 15px; }

  .ul-modal-footer {
    padding: 16px 24px;
    border-top: 1px solid #f0eded;
    display: flex; align-items: center; justify-content: space-between;
    flex-shrink: 0;
    flex-wrap: wrap; gap: 12px;
    background: #fdf2f1;
  }
  .ul-cart-totals { display: flex; gap: 24px; align-items: center; flex-wrap: wrap; }
  .ul-total-item { font-size: 14px; color: #666; }
  .ul-total-item strong {
    font-size: 16px; font-weight: 700; color: #1c0a0a;
    font-family: 'JetBrains Mono', monospace; display: block; margin-top: 2px;
  }
  .ul-total-item.discounted strong { color: #27ae60; }

    /* cart summary badge */
  .ul-cart-info {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 8px;
    background: #fdf2f1;
    color: #a60808;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 6px;
    font-family: 'DM Sans', sans-serif;
  }
  .ul-cart-info .ul-cart-price-strong {
    font-family: 'JetBrains Mono', monospace;
    font-size: 14px;
    font-weight: 700;
  }
  .ul-cart-info .ul-cart-price-strike {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    font-weight: 500;
    color: #999;
    text-decoration: line-through;
    margin-left: 4px;
  }
  .ul-cart-empty-txt {
    font-size: 12px;
    color: #bbb;
    margin-bottom: 6px;
  }
`;

function UserList() {

    const getImageUrl = (image) => {
          if (!image) return "";
          if (image.startsWith("http")) return image;
          return `${IMAGE_BASE_URL}${image}`;
        };
      

  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [showCartModal, setShowCartModal] = useState(false);
  const [selectedCart, setSelectedCart] = useState([]);
  const [actualTotal, setActualTotal] = useState(0);
  const [discountedTotal, setDiscountedTotal] = useState(0);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [totalPages, setTotalPages] = useState(1);

  const [payload, setPayload] = useState({
    searchKey: "", status: "", pageNo: 1, pageCount: 10, sortByField: "",
  });
  const [showSkelton, setShowSkelton] = useState(false);

  const handleGetUserFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getUserListServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  useEffect(() => { handleGetUserFunc(); }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) setPayload({ ...payload, pageNo: newPage });
  };

  const handleDeleteUserFunc = async (id) => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        let response = await deleteUserServ(id);
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetUserFunc();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Internal Server Error");
      }
    }
  };

  const handleViewCart = async (userId) => {
    try {
      const res = await getUserCartServ(userId);
      const data = res.data;
      if (data?.statusCode === 200) {
        setSelectedCart(data.cartItems);
        setActualTotal(data.actualTotalAmount);
        setDiscountedTotal(data.discountedTotalAmount);
        setShowCartModal(true);
      } else {
        toast.error(data?.message || "Failed to fetch cart");
      }
    } catch (err) {
      toast.error("Something went wrong while fetching cart items");
    }
  };

  const handleDownload = async (format) => {
    setShowDownloadMenu(false);
    try {
      const response = await exportUserServ(payload, format);
      const ext = format === "excel" ? "xlsx" : format;
      triggerFileDownload(response.data, `UserList.${ext}`);
    } catch (err) {
      toast.error("Download failed");
    }
  };

  const getInitials = (v) =>
    [v?.firstName, v?.lastName].filter(Boolean).map((n) => n[0]).join("").toUpperCase().slice(0, 2) || "U";

  return (
    <div className="bodyContainer">
      <style>{styles}</style>
      <Sidebar selectedMenu="User Management" selectedItem="Users" />
      <div className="mainContainer">
        <TopNav pageTitle="Users" pagePath="Home / User Management / Users" />
        <div className="ul-root">

          {/* ── Stat Card ── */}
          <div className="ul-stat-grid">
            <div className="ul-stat-card">
              <div className="ul-stat-icon">👥</div>
              <div>
                <div className="ul-stat-val">{statics?.totalCount ?? "—"}</div>
                <div className="ul-stat-lbl">Total Users</div>
              </div>
            </div>
          </div>

          {/* ── Toolbar ── */}
          <div className="ul-toolbar">
            <div className="ul-toolbar-title">Users</div>

            <input
              className="ul-input"
              placeholder="🔍  Search users..."
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
            />

            <div className="ul-download-wrap">
              <button className="ul-btn ul-btn-blue" onClick={() => setShowDownloadMenu((p) => !p)}>
                <i className="ti ti-download" /> Download
              </button>
              {showDownloadMenu && (
                <div className="ul-dropdown-menu">
                  <button className="ul-dropdown-item" onClick={() => handleDownload("txt")}>Download as TXT</button>
                  <button className="ul-dropdown-item" onClick={() => handleDownload("excel")}>Download as Excel</button>
                  <button className="ul-dropdown-item" onClick={() => handleDownload("csv")}>Download as CSV</button>
                </div>
              )}
            </div>
          </div>

          {/* ── Table ── */}
          <div className="ul-table-wrap">
            <div className="ul-table-scroll">
              <table className="ul-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>User</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Signed Up</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(6)].map((__, j) => (
                          <td key={j} className="ul-skel-cell"><Skeleton height={20} /></td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center", padding: "50px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => {
                      const fullName = [v?.firstName, v?.lastName].filter(Boolean).join(" ") || "—";
                      return (
                        <tr key={v._id}>
                          {/* Sr */}
                          <td>
                            <span className="ul-sr">
                              {(payload.pageNo - 1) * payload.pageCount + i + 1}
                            </span>
                          </td>

                          {/* User */}
                          <td>
                            <div className="ul-user-cell">
                              {v?.profilePic ? (
                                <img src={getImageUrl(v.profilePic)} alt="" className="ul-avatar" />
                              ) : (
                                <div className="ul-avatar-initials">{getInitials(v)}</div>
                              )}
                              <div>
                                <div className="ul-user-name">{fullName}</div>
                                <div className="ul-user-sub">Customer</div>
                              </div>
                            </div>
                          </td>

                          {/* Phone */}
                          <td>
                            <span className="ul-mono">{v?.phone || "—"}</span>
                          </td>

                          {/* Email */}
                          <td>
                            <span className="ul-email">{v?.email || "—"}</span>
                          </td>

                          {/* Signed Up */}
                          <td>
                            {v?.createdAt ? (
                              <>
                                <div className="ul-date-main">{moment(v.createdAt).format("DD MMM YYYY")}</div>
                                <div className="ul-date-sub">{moment(v.createdAt).format("hh:mm A")}</div>
                              </>
                            ) : "—"}
                          </td>

                          {/* Action */}
                          {/* <td style={{ whiteSpace: "nowrap" }}>
                            <button className="ul-cart-btn" onClick={() => handleViewCart(v?._id)}>
                              <i className="ti ti-shopping-cart" /> View Cart
                            </button>
                            <button className="ul-del-btn" onClick={() => handleDeleteUserFunc(v?._id)}>
                              <i className="ti ti-trash" /> Delete
                            </button>
                          </td> */}
                          {/* Action */}
<td style={{ whiteSpace: "nowrap" }}>
  {v?.cartItemCount > 0 ? (
    <div className="ul-cart-info">
      🛒 {v.cartItemCount} item{v.cartItemCount > 1 ? "s" : ""}
      <span className="mx-1">·</span>
      <span className="ul-cart-price-strong">
        ₹{Number(v.cartDiscountedTotal || 0).toLocaleString("en-IN")}
      </span>
      {v.cartActualTotal > v.cartDiscountedTotal && (
        <span className="ul-cart-price-strike">
          ₹{Number(v.cartActualTotal).toLocaleString("en-IN")}
        </span>
      )}
    </div>
  ) : (
    <div className="ul-cart-empty-txt">Cart empty</div>
  )}

  <button
    className="ul-cart-btn"
    onClick={() => handleViewCart(v?._id)}
  >
    <i className="ti ti-shopping-cart" /> View Cart
  </button>
  <button
    className="ul-del-btn"
    onClick={() => handleDeleteUserFunc(v?._id)}
  >
    <i className="ti ti-trash" /> Delete
  </button>
</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="ul-pagination">
              <div className="ul-show-row">
                Show
                <select
                  className="ul-select"
                  style={{ height: "34px", padding: "0 10px", minWidth: "unset" }}
                  value={payload.pageCount}
                  onChange={(e) => setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })}
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="ul-page-btns">
                <button className="ul-pg-btn" disabled={payload.pageNo === 1} onClick={() => handlePageChange(payload.pageNo - 1)}>
                  <i className="ti ti-chevron-left" style={{ fontSize: 14 }} />
                </button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages || (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)) {
                    return (
                      <button key={page} className={`ul-pg-btn ${payload.pageNo === page ? "active" : ""}`} onClick={() => handlePageChange(page)}>
                        {page}
                      </button>
                    );
                  } else if ((page === payload.pageNo - 2 && page > 2) || (page === payload.pageNo + 2 && page < totalPages - 1)) {
                    return <button key={page} className="ul-pg-btn" disabled>…</button>;
                  }
                  return null;
                })}
                <button className="ul-pg-btn" disabled={payload.pageNo === totalPages} onClick={() => handlePageChange(payload.pageNo + 1)}>
                  <i className="ti ti-chevron-right" style={{ fontSize: 14 }} />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ── Cart Modal ── */}
      {showCartModal && (
        <div className="ul-modal-overlay" onClick={() => setShowCartModal(false)}>
          <div className="ul-modal" onClick={(e) => e.stopPropagation()}>

            <div className="ul-modal-header">
              <div className="ul-modal-title">
                <div className="ul-modal-title-icon">
                  <i className="ti ti-shopping-cart" />
                </div>
                User Cart Items
              </div>
              <button className="ul-modal-close" onClick={() => setShowCartModal(false)}>
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="ul-modal-body">
              <table className="ul-cart-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Discounted</th>
                    <th>Item Total</th>
                    <th>Disc. Total</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCart.length > 0 ? (
                    selectedCart.map((item, idx) => (
                      <tr key={idx}>
                        <td>
                          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                             <img src={getImageUrl(item.productHeroImage)} alt={item.name} className="ul-cart-img" />
                            <span className="ul-cart-name">{item.name}</span>
                          </div>
                        </td>
                        <td><span className="ul-cart-qty">{item.quantity}</span></td>
                        <td><span className="ul-cart-price">Rs {item.price}</span></td>
                        <td><span className="ul-cart-price">Rs {item.discountedPrice}</span></td>
                        <td><span className="ul-cart-price main">Rs {item.totalItemPrice}</span></td>
                        <td><span className="ul-cart-price" style={{ color: "#27ae60", fontWeight: 700 }}>Rs {item.totalItemDiscountedPrice}</span></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="ul-cart-empty">
                        🛒 No items in cart
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="ul-modal-footer">
              <div className="ul-cart-totals">
                <div className="ul-total-item">
                  <span>Cart Total</span>
                  <strong>Rs {actualTotal}</strong>
                </div>
                <div className="ul-total-item discounted">
                  <span>After Discount</span>
                  <strong>Rs {discountedTotal}</strong>
                </div>
              </div>
              <button
                className="ul-btn"
                style={{ background: "#1c0a0a", color: "#fff" }}
                onClick={() => setShowCartModal(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default UserList;